import noticeApi from "@/api/noticeApi/noticeApi";
import { GetUserMessageListResponse } from "@/api/noticeApi/noticeLimit";
import { ref } from "vue";

interface Lists {
  year: string;
  arr: GetUserMessageListResponse[];
}
export const useNoticeMain = () => {
  const lists = ref<Lists[]>([]);
  const loading = ref(false);

  const getUserMessageList = async () => {
    try {
      loading.value = true;
      const { data } = await noticeApi.GetUserMessageList();
      const obj: { [key: string]: GetUserMessageListResponse[] } = {};
      data.forEach((item: GetUserMessageListResponse) => {
        const { year } = item;
        if (!obj[year]) obj[year] = [];
        obj[year].push(item);
      });

      lists.value = Object.keys(obj)
        .map((year) => ({
          year,
          arr: obj[year],
        }))
        .sort((a, b) => Number(b.year) - Number(a.year));
    } finally {
      loading.value = false;
    }
  };

  return {
    lists,
    loading,
    getUserMessageList,
  };
};

export const useNoticeIndex = () => {
  const count = ref<number>(0);

  const getUserCount = async () => {
    const { data } = await noticeApi.GetUserMessageCount();
    count.value = data;
  };
  getUserCount();
  return { count, getUserCount };
};
